import esupplyvetApi from "./esupplyvet";
import api from "./index";
import { useRegisterStore } from "@/stores/register";

function getHttpClient() {
  const registerStore = useRegisterStore();
  const userRole = registerStore.user?.role || "";
  return userRole === "client" ? esupplyvetApi : api;
}

/**
 * Fetches pickup points for a given zip code
 * @param {Object} params - Can contain zipCode, city, or address
 * @returns {Promise} API response containing list of pickup points
 */
export function getPickupPoints(tokenValue, params) {
  return getHttpClient().get(`/${tokenValue}/get-pickup-points`, {
    params,
  });
}